<template>
  <div class="root">
    <div class="title bg-purple">回单情况</div>
    <el-form class="form" size="mini" label-position="left" label-width="70px">
      <el-form-item label="回单状态">{{
        rn.retractionStatusShow
      }}</el-form-item>
      <el-form-item label="回单附件">
        <el-button type="text" v-if="rn.fileId" @click="checkPic"
          >查看</el-button
        >
      </el-form-item>
      <el-form-item label="返回开始网点时间">{{
        rn.rnOpenDeptTime
      }}</el-form-item>
      <el-form-item label="返回人">{{ rn.receiveOperationEmpName }}</el-form-item>
      <el-form-item label="返回客户时间">{{ rn.rnCustomerTime }}</el-form-item>
      <el-form-item label="返回人">{{ rn.rnReceiveName }}</el-form-item>
    </el-form>
    <my-image-view :show.sync="showViewer" :url-list="previewSrcList" />
  </div>
</template>

<script>
import MyImageView from "@/components/MyImageView.vue";
export default {
  components: {
    MyImageView,
  },
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      rn: {
        retractionStatusShow: "",
        fileId: "",
        rnOpenDeptTime: "",
        rnUserName: "",
        rnCustomerTime: "",
        rnReceiveName:'',
        receiveOperationEmpName:''
      },
      fileUrls: "",
      previewSrcList: [],
      files: [],
      showViewer: false,
    };
  },
  watch: {
    waybillSplitId(val) {
      if (!val) {
        return;
      }
      this.getData();
    },
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData() {
      if(!this.waybillSplitId){
        return
      }
      const res = await this.$API.runDetail({
        number: "admin_waybill_sum_all_rn_info_v5",
        waybillSplitId: this.waybillSplitId,
      });
      this.rn = res;
    },
    async checkPic() {
      const res = await this.$API.getFileUrlMore({
        fileNames: this.rn.fileId.split(','),
      });
      this.fileUrls = res.data.result;
      this.previewSrcList = this.fileUrls.map(item=>item.url);
      this.showViewer = true;
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  width: 100%;
  height: 100%;
  .title {
    display: flex;
    justify-content: center;
    height: 35px;
    line-height: 35px;
  }
  .el-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>